
const tags = {
    payment: 'Payment',
    cancellation: 'Cancellation',
    account: 'Account',
    other: 'Other',
}

const faqs = [
    {
        id: 1,
        question: "How do I change my email address?",
        answer: "To change your email address, please contact support.",
        tags: [tags.account],
    },
]

export default faqs